module.exports = __webpack_public_path__ + "static/media/Amanda M.f7339d00.jpeg";